import React, { useEffect, useRef, useState } from 'react';
import { TextField, FormControl, InputLabel, Select, MenuItem, Grid, Paper, useMediaQuery, Button, FormHelperText, Radio, RadioGroup, FormControlLabel, FormLabel, CircularProgress } from '@mui/material';
import styled, { inputImages, inputStyles } from '../../Utils/inputChanges';
import 'react-toastify/dist/ReactToastify.css';
import { toast, ToastContainer } from 'react-toastify';
import { errorStyles } from '../../Utils/table';
import { useDispatch, useSelector } from 'react-redux';
import { fetchStatesData } from '../../Store/PHPSlice/States';
import { fetchSingleVendor, updateVendorEntry } from '../../Store/PHPSlice/Vednor';
import { useParams } from 'react-router-dom';
import { selectFirm, selectParty, selectPriPerGrp, selectSingleVendor, selectState } from '../Selectors/Master/ItemSelectors';
import { fetchCompanyData } from '../../Store/PHPSlice/Firm';
import { fetchPricePerData } from '../../Store/PHPSlice/Sale/PricePercent';
import DateInputComponent from '../FieldsComponents/DateInputComponent';
import RadioComponent from '../FieldsComponents/RadioComponent';
import DropdownWithBtn from '../FieldsComponents/DropdownWithBtn';



const VendorEdit = () => {
    const { Id } = useParams();
    const userdata = JSON.parse(localStorage.getItem('user'));
    const [formData, setFormData] = useState({
        vendorId: parseInt(Id),
        vendorNm: '',
        ph1: '',
        ph2: '',
        emailId: '',
        adrs: '',
        gstType: '',
        gst: '',
        pan: '',
        state: '',
        stateNm: '',
        statecd: '',
        vendorType: '',
        userId: userdata?.ID
    });
    const [errors, setErrors] = useState({});
    const [loading, setLoading] = useState(false);
    const isDesktop = useMediaQuery('(min-width:768px)'); // Adjust the breakpoint as per your requirement
    const gstInputRef = useRef(null); // Reference for GST input field

    const dispatch = useDispatch();
    const firmlist = useSelector(selectFirm);
    const getStates = useSelector(selectState);
    const grouplist = useSelector(selectPriPerGrp);
    const singleVendor = useSelector(selectSingleVendor);
     console.log("singlevendor=>",singleVendor);
    const [openDropdowns, setOpenDropdowns] = useState({});
    const actionMap = {
        groupId: fetchPricePerData
        // Add more mappings if needed
    };
    useEffect(() => {
        dispatch(fetchStatesData());
        dispatch(fetchCompanyData());
        dispatch(fetchPricePerData());
        Object.keys(openDropdowns).forEach((dropdown) => {
            if (openDropdowns[dropdown]) {
                const action = actionMap[dropdown];
                if (action) {
                    dispatch(action());
                }
            }
        });
    }, [dispatch, openDropdowns]);

    useEffect(() => {

        dispatch(fetchSingleVendor(Id));
    }, [dispatch,Id]);
    useEffect(() => {
        if (formData.gstType === 'yes') {
            gstInputRef.current.focus();
        }
    }, [formData.gstType]);
useEffect(() => {
    if (singleVendor?.data?.length > 0) {

        const item = singleVendor.data[0];

        setFormData(prev => ({
            ...prev,
            vendorNm: item.vendorNm,
            ph1: item.contact,
            ph2: item.contact2,
            emailId: item.emailId,
            adrs: item.adrs,
            gstType: item.gst_type,
            gst: item.gst,
            pan: item.pan,
            state: item.state_type,
            stateNm: item.stateNm,
            statecd: item.statecd,
            vendorType: item.vendorType,
            groupId: item.groupId
        }));

    }
}, [singleVendor]);

    if (!singleVendor) {
        return <h1>Loading...</h1>
    }

    const handleInputChange = (e) => {
        const { name, value } = e.target;

        // Handle numerical inputs for contactNo and accNo
        if (name === 'ph1' || name === 'ph2') {
            if (!/^\d*$/.test(value)) {
                return;
            }
        }

        // Ensure contactNo is only 10 digits
        if (name === 'ph1' && value.length > 10) {
            return;
        }
        if (name === 'ph2' && value.length > 10) {
            return;
        }


        setFormData({
            ...formData,
            [name]: value.toUpperCase()
        });
    };

    const handleDropdownOpen = (dropdown) => {
        setOpenDropdowns((prev) => ({ ...prev, [dropdown]: true }));
    };

    const handleDropdownClose = (dropdown) => {
        setOpenDropdowns((prev) => ({ ...prev, [dropdown]: false }));
    };

    const handleDropdownChange = (e, dropdownType) => {
        const { value } = e.target;

        if (dropdownType === 'stateNm') {
            const selectedState = getStates.data.find((state) => state.stateName === value);
            const stateCode = selectedState ? selectedState.codes : '';

            setFormData({
                ...formData,
                stateNm: value,
                statecd: stateCode
            });
        } else {
            setFormData({
                ...formData,
                [dropdownType]: value
            });
        }
    };

    const handleDateChange = (e) => {
        const { name, value } = e.target;
        setFormData(prevFormData => ({
            ...prevFormData,
            [name]: value
        }));
    };

    const handleRadioChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value
        });
    };

    const validate = () => {
        const newErrors = {};
        if (!formData.vendorNm) newErrors.vendorNm = 'Vendor Name is required';
        if (!formData.ph1) newErrors.ph1 = 'Contact No is required';
        if (!formData.stateNm) newErrors.stateNm = 'State Name is required';
        // if (!formData.pan) newErrors.pan = 'Pan is required';
        if (!formData.ph1) {
            newErrors.ph1 = 'Contact is required';
        } else if (!/^\d{10}$/.test(formData.ph1)) {
            newErrors.ph1 = 'Contact must be a 10-digit number';
        }
        if (!formData.adrs) newErrors.adrs = 'Address is required';
        if (formData.emailId && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(formData.emailId)) {
            newErrors.emailId = 'Invalid email address';
        }
        // if (!formData.firmId) newErrors.firmId = 'Firm is required';
        return newErrors;
    };



    const handleSubmit = async (event) => {
        event.preventDefault();
        // const validationErrors = validate();
        // if (Object.keys(validationErrors).length > 0) {
        //     setErrors(validationErrors);
        //     return;
        // }
        // console.log(formData);

        setLoading(true);

        try {
            const result = await dispatch(updateVendorEntry(formData)).unwrap();
            console.log('POST request successful!', result);
            // toast.success("Party Updated Successful");
            alert("Vendor Updated Successful");
            window.close();
        } catch (error) {
            console.error('Error while making POST request:', error);
        } finally {
            setLoading(false);
        }

    };

    const vendorType = [
        { label: 'Main Vendor', value: 1 },
        { label: 'Sub Vendor', value: 2 },
        { label: 'Both', value: 3 }
    ];

    const fields = [
        { label: 'Vendor Name', name: 'vendorNm' },
        { label: 'Email', name: 'emailId' },
        { label: 'Contact No1', name: 'ph1' },
        { label: 'Contact No2', name: 'ph2' },
        { label: 'Address', name: 'adrs' },
        { label: 'Pan', name: 'pan' },
    ];

    const gstOptions = [
        { label: 'No', value: "1" },
        { label: 'Yes', value: "0" },
    ];


    const stateOptions = [
        { label: 'Inside', value: "0" },
        { label: 'Outside', value: "1" },
    ];

    const dropdownlist = [
        {
            label: 'State Name',
            id: 'stateNm',
            options: getStates?.data || [],
            value: formData.stateNm,
            onChange: (newValue) => handleDropdownChange({ target: { name: 'stateNm', value: newValue ? newValue.stateName : '' } }, 'stateNm'),
            getOptionLabel: (option) => option.stateName || '',
            isOptionEqualToValue: (option, value) => option.stateName === value.stateName,
            valueFinder: (options, value) => {
                if (Array.isArray(options)) {
                    return options.find(item => item.stateName === value) || null;
                }
                return null;
            },

        },
    ];
    const handleNavitoRetailer = () => {
        window.open(`/new-price-percentage-group`, '_blank', 'width=800,height=600,scrollbars=yes,resizable=yes');

    };

    const dropdownlist2 = [
        {
            label: 'Vendor Type',
            id: 'vendorType',
            options: vendorType || [],
            value: formData.vendorType,
            onChange: (newValue) => handleDropdownChange({ target: { name: 'vendorType', value: newValue ? newValue.value : '' } }, 'vendorType'),
            getOptionLabel: (option) => option.label || '',
            isOptionEqualToValue: (option, value) => option.value === value.value,
            valueFinder: (options, value) => {
                if (Array.isArray(options)) {
                    return options.find(item => item.value === value) || null;
                }
                return null;
            },

        },

    ];


    const fields2 = [
        { label: 'State Code', name: 'statecd', type: 'readOnly' },
    ];

    const GroupOptions = [
        { label: 'No', value: "0" },
        { label: 'Yes', value: "1" },
    ];

    const dropdownlist3 = [
        {
            label: 'Group Id',
            id: 'groupId',
            options: grouplist?.data || [],
            value: formData.groupId,
            onChange: (newValue) => handleDropdownChange({ target: { name: 'groupId', value: newValue ? newValue.ID : '' } }, 'groupId'),
            getOptionLabel: (option) => option.groupId || '',
            isOptionEqualToValue: (option, value) => option.ID === value.ID,
            valueFinder: (options, value) => {
                if (Array.isArray(options)) {
                    return options.find(item => item.ID === value) || null;
                }
                return null;
            },
            handleAddNew: () => handleNavitoRetailer(),
            btnlabel: 'New',
            handleDropdownOpen: () => handleDropdownOpen('groupId'),
            handleDropdownClose: () => handleDropdownClose('groupId'),
        },
    ];
    return (
        <>
            <div style={{ margin: '1%' }}>
                <h2>Vendor Edit</h2>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Paper style={{ padding: '3vh', margin: '0' }}>
                            <Grid container spacing={2}>
                                {fields?.map((field) => (
                                    <DateInputComponent
                                        key={field.name}
                                        formData={formData}
                                        handleDateChange={handleDateChange}
                                        handleInputChange={handleInputChange}
                                        styled={styled}
                                        inputStyles={inputStyles}
                                        isDesktop={isDesktop}
                                        field={field}
                                    />
                                ))}

                                <RadioComponent
                                    label='GST Type'
                                    name='gstType'
                                    value={formData.gstType}
                                    options={gstOptions}
                                    isDesktop={isDesktop}
                                    onChange={handleRadioChange}
                                />


                                {[
                                    { label: 'GST', name: 'gst' },
                                ].map((field, index) => (
                                    <Grid item xs={12} md={6} key={index}>
                                        <Grid container alignItems="center" spacing={1}>
                                            <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                                <InputLabel htmlFor={field.name} >{field.label}:</InputLabel>
                                            </Grid>
                                            <Grid item xs>
                                                <FormControl fullWidth>

                                                    <TextField
                                                        id={field.name}
                                                        name={field.name}
                                                        value={formData[field.name]}
                                                        onChange={handleInputChange}
                                                        inputProps={{ style: styled.input }}
                                                        sx={inputStyles}
                                                        disabled={formData.gstType === '1'}
                                                        inputRef={gstInputRef}
                                                    />

                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                ))}


                                <RadioComponent
                                    label='State'
                                    name='state'
                                    value={formData.state}
                                    options={stateOptions}
                                    isDesktop={isDesktop}
                                    onChange={handleRadioChange}
                                />

                                {
                                    dropdownlist?.map((drop) => (
                                        <DropdownWithBtn
                                            key={drop.label}
                                            label={drop.label}
                                            id={drop.id}
                                            options={drop.options}
                                            value={drop.value}
                                            onChange={drop.onChange}
                                            isDesktop={isDesktop}
                                            getOptionLabel={drop.getOptionLabel}
                                            isOptionEqualToValue={drop.isOptionEqualToValue}
                                            valueFinder={drop.valueFinder}  // Pass `valueFinder` function here
                                        // handleAddNew={drop.handleAddNew}
                                        // btnlabel={drop.btnlabel}
                                        // handleDropdownOpen={drop.handleDropdownOpen}
                                        // handleDropdownClose={drop.handleDropdownClose}
                                        />
                                    ))
                                }

                                {fields2?.map((field) => (
                                    <DateInputComponent
                                        key={field.name}
                                        formData={formData}
                                        handleDateChange={handleDateChange}
                                        handleInputChange={handleInputChange}
                                        styled={styled}
                                        inputStyles={inputStyles}
                                        isDesktop={isDesktop}
                                        field={field}
                                    />
                                ))}



                                {
                                    dropdownlist2?.map((drop) => (
                                        <DropdownWithBtn
                                            key={drop.label}
                                            label={drop.label}
                                            id={drop.id}
                                            options={drop.options}
                                            value={drop.value}
                                            onChange={drop.onChange}
                                            isDesktop={isDesktop}
                                            getOptionLabel={drop.getOptionLabel}
                                            isOptionEqualToValue={drop.isOptionEqualToValue}
                                            valueFinder={drop.valueFinder}  // Pass `valueFinder` function here
                                            handleAddNew={drop.handleAddNew}
                                            btnlabel={drop.btnlabel}
                                            handleDropdownOpen={drop.handleDropdownOpen}
                                            handleDropdownClose={drop.handleDropdownClose}
                                        />
                                    ))
                                }


                               
                                <Grid item xs={12} textAlign="center">
                                    <Button variant="contained" color="primary" onClick={handleSubmit} disabled={loading === true}>
                                        {
                                            loading === true ?
                                                <><CircularProgress size="20px" /> wait...</> :
                                                "Submit"
                                        }
                                    </Button>
                                </Grid>
                            </Grid>
                            <ToastContainer />
                        </Paper>
                    </Grid>
                </Grid>

            </div>
        </>
    );
}

export default VendorEdit;
